import React, { Component } from "react";
import "./styles/customDatePickerInput.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class CustomDatePickerInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tempValue: props.value || ""
    };
    this.typingTimer = null;
    //Set a 800ms delay to give user enough time to type in double digit month or day
    //Without the delay, user typing in 1 for the month will default immediately to 01 (Jan)
    this.typingDelay = 800;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.value !== this.state.tempValue) {
      this.setState({ tempValue: this.props.value || "" });
    }
  }

  handleInputChange = (e) => {
    const newValue = e.target.value;
    this.setState({ tempValue: newValue });

    clearTimeout(this.typingTimer);

    this.typingTimer = setTimeout(() => {
      if (this.props.onChange) {
        this.props.onChange(e);
      }
    }, this.typingDelay);
  };

  handleInputBlur = (e) => {
    clearTimeout(this.typingTimer);
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  };

  componentWillUnmount() {
    clearTimeout(this.typingTimer);
  }

  render() {
    const { onClick, disabled, isClearable, onClear, disableClear } = this.props;
    const { tempValue } = this.state;

    if (!isClearable) {
      return (
        <input
          type="text"
          className="form-control custom-datePicker-input"
          onClick={onClick}
          value={tempValue}
          disabled={disabled}
          onChange={this.handleInputChange}
          onBlur={this.handleInputBlur}
          placeholder="MM/DD/YYYY"
        />
      );
    } else {
      return (
        <div className="input-group mb-0">
          <input
            type="text"
            className="form-control custom-datePicker-input"
            onClick={onClick}
            value={tempValue}
            disabled={disabled}
            onChange={this.handleInputChange}
            onBlur={this.handleInputBlur}
            placeholder="MM/DD/YYYY"
          />
          <div className="input-group-append">
            <button
              className="btn btn-outline-secondary px-2"
              type="button"
              onClick={onClear}
              disabled={disableClear}
            >
              <FontAwesomeIcon icon="times" className="fa-fw mx-0" />
            </button>
          </div>
        </div>
      );
    }
  }
}

export default CustomDatePickerInput;
